/**
 * 진행도 조회 화면의 선택 상태 관리
 *
 * option "lesson": 학급 → 과제 → 학생 순 선택
 * option "student": 학생 → 과제 순 선택 (보충 과제 포함)
 *
 * 탭 전환 시 selection을 초기화해 이전 탭의 stale 상태가 남지 않도록 함
 */
import { useState } from "react"
import { report, student } from "shared/types/Homework";

interface SelectionState {
    lessonId: string;
    student: student | undefined;
    report: report | undefined;
}

const useHomeworkProgressView = () => {
    const [selection, setSelection] = useState<SelectionState>({
        lessonId: "",
        student: undefined,
        report: undefined
    });
    const [option, setOption] = useState<"lesson" | "student">("lesson");

    const onLessonClickHandler = (id:string) => {
        setSelection(prev => ({
            ...prev,
            lessonId: id,
            report: undefined,
            student: undefined
        }));
    }

    const onStudentClickHandler = (student:student | undefined) => {
        setSelection(prev => ({
            ...prev,
            student
        }));
    }

    const onReportClickHandler = (report:report | undefined) => {
        setSelection(prev => ({
            ...prev,
            report
        }));
    }

    const onOptionChangeHandler = (option: "lesson" | "student") => {
        setOption(option);
        setSelection({
            lessonId: "",
            student: undefined,
            report: undefined
        });
    }

    const onStudentAndLessonSelect = (student: student, lessonId: string) => {
        setSelection({
            lessonId,
            student,
            report: undefined
        });
    }

    return {
        selectedLesson: selection.lessonId,
        onLessonClickHandler,
        selectedStudent: selection.student,
        onStudentClickHandler,
        selectedReport: selection.report,
        onReportClickHandler,
        option,
        onOptionChangeHandler,
        onStudentAndLessonSelect
    };
}

export default useHomeworkProgressView;